export default {
  lang: {
    selectAll: 'Sayfa olarak hepsini seçin',
    selected: 'Seçildi',
    term: 'Madde',
    deselect: 'Seçimi iptal et',
  },
};
